type ServiceConstructor<T = unknown> = abstract new (...args: never[]) => T;

const instances = new Map<ServiceConstructor<unknown> | string, unknown>();

const ServiceRegistry = {
    get<T>(ServiceClass: ServiceConstructor<T> | string): T {
        const key = typeof ServiceClass === 'string' ? ServiceClass : ServiceClass;
        if (!instances.has(key)) {
            throw new Error(`Service not registered: ${typeof ServiceClass === 'string' ? ServiceClass : ServiceClass.name}`);
        }
        return instances.get(key) as T;
    },

    register<T>(ServiceClass: ServiceConstructor<T> | string, instance: T): void {
        const key = typeof ServiceClass === 'string' ? ServiceClass : ServiceClass;
        instances.set(key, instance);
    },

    clear(): void {
        instances.clear();
    }
};

export default ServiceRegistry;